<template>
    <div id="services">
        <h1 class="mb-4 py-4 text-center">{{ lang.services }}</h1>

        <div class="container text-center">
            <div class="d-sm-flex no-gutters mb-3">
                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/colocations.png" alt="">

                        <h4>Colocations</h4>
                    </div>
                </div>

                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower4.png" alt="">

                        <h4>Antenna and Line Installation</h4>
                    </div>
                </div>

                <div class="square d-flex justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower3.png" alt="">

                        <h4>Tower Modifications</h4>
                    </div>
                </div>
            </div>

            <div class="d-sm-flex no-gutters mb-3">
                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/grounding.png" alt="">

                        <h4>Grounding</h4>
                    </div>
                </div>

                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/truck-concrete.jpg" alt="">

                        <h4>Foundation for Towers & Shelters</h4>
                    </div>
                </div>

                <div class="square d-flex justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower5.png" alt="">

                        <h4>Electrical Telco Installations</h4>
                    </div>
                </div>
            </div>

            <div class="d-sm-flex no-gutters mb-3">
                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/cabinet.svg" alt="">

                        <h4>Shelters and Cabinet Installation</h4>
                    </div>
                </div>

                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower-maintenance.png" alt="">

                        <h4>Tower Maintenance</h4>
                    </div>
                </div>

                <div class="square d-flex justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower-stacking.png" alt="">

                        <h4>Tower Stacking</h4>
                    </div>
                </div>
            </div>

            <div class="d-sm-flex no-gutters mb-3">
                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/tower-decommission.png" alt="">

                        <h4>Decommission</h4>
                    </div>
                </div>

                <div class="square d-flex mr-3 justify-content-center align-items-center">
                    <div>
                        <img src="/static/communication.png" alt="">

                        <h4>Communication</h4>
                    </div>
                </div>

                <div class="square d-flex justify-content-center align-items-center">
                    <div>
                        <i class="fas fa-user-friends"></i>

                        <h4>Civil Services</h4>
                    </div>
                </div>
            </div>

            <div class="d-sm-flex no-gutters justify-content-center">
                <div class="square d-flex justify-content-center align-items-center last">
                    <div>
                        <img src="/static/rawland.png" alt="">

                        <h4>Raw Land</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import text from './language'

  export default {
    name: 'Services',

    computed: {
      lang () {
        return this.eng ? this.text.en : this.text.sp
      }
    },

    data () {
      return {
        text
      }
    },

    props: ['eng']
  }
</script>

<style lang="sass" scoped>
#services
    padding-top: 50px
    padding-bottom: 150px

.square
    background-color: white
    height: 300px
    width: 33%
    border: 2px solid #e3e3e3
    border-radius: 5px

    &.last
        width: calc(33% - 6px)

    h4
        font-weight: bold
        font-size: 20px

    i
        font-size: 110px
        margin-bottom: 30px

    img
        height: 110px
        margin-bottom: 30px

@media (max-width: 414px)
    .square,
    .square.last
        width: 100%
        margin-bottom: 5px
</style>



// WEBPACK FOOTER //
// src/components/Services.vue